import { useEffect, useState } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { Manifesto } from "./components/Manifesto";
import { Reviews } from "./components/Reviews";
import { AuthorBio } from "./components/AuthorBio";
import { Newsletter } from "./components/Newsletter";
import { Footer } from "./components/Footer";
import { ChapterReader } from "./components/ChapterReader";

function App() {
  const [readerOpen, setReaderOpen] = useState(false);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0E] text-[#F2EFE9]">
      <div className="noise-overlay" />
      <Navbar onOpenReader={() => setReaderOpen(true)} />
      <main>
        <Hero onOpenReader={() => setReaderOpen(true)} />
        <Marquee />
        <Manifesto />
        <Reviews />
        <AuthorBio />
        <Newsletter />
      </main>
      <Footer />
      <ChapterReader open={readerOpen} onClose={() => setReaderOpen(false)} />
      <Toaster position="bottom-center" theme="dark" />
    </div>
  );
}

export default App;
